import React from "react";

export default function Footer() {
    return (
        <footer className="footer-container text-center">
            <div className="container">
                <div className="row">
                    <div className="col-xs-12">
                        <p>Website created by Tanner Metzmeier</p>
                    </div>
                </div>
            </div>
        </footer>
    );
}